import { useFormatDate } from "@dgs/core";
import { isSameDay } from "date-fns";
import { FC } from "react";

interface Props {
	arrivalDate: string;
	departureDate: string;
}

export const TravelSegmentDateRange: FC<Props> = ({ arrivalDate, departureDate }) => {
	const formatDate = useFormatDate();

	if (isSameDay(departureDate, arrivalDate)) {
		return <span>{formatDate(departureDate, { day: "2-digit", month: "2-digit" })}</span>;
	} else {
		return (
			<span>
				{formatDate(departureDate, { day: "2-digit", month: "2-digit" })} -{" "}
				{formatDate(arrivalDate, { day: "2-digit", month: "2-digit" })}
			</span>
		);
	}
};
